import RolePermissions from "./RolePermissions";

interface CreateRoleProps {
    setShowPermissionsSection: (value: boolean) => void;
    setFlag: (value: boolean) => void;
}
const CreateRole = ({
    setShowPermissionsSection,
    setFlag
}: CreateRoleProps) => {

    return (
        <>
            <RolePermissions 
                setShowPermissionsSection={setShowPermissionsSection}
                action={'create-role'}
                setFlag={setFlag}
            />
        </>
    );
}

export default CreateRole;